import { TrendingUp, Users, Wallet, Activity } from "lucide-react";

const stats = [
  { label: "Success Rate", value: "78%", icon: Activity, color: "text-primary" },
  { label: "Active Members", value: "50K+", icon: Users, color: "text-blue-400" },
  { label: "Total Profit", value: "$2.4M", icon: Wallet, color: "text-yellow-400" },
  { label: "Monthly ROI", value: "+145%", icon: TrendingUp, color: "text-emerald-400" },
];

export function Stats() {
  return (
    <section className="py-12 border-y border-white/5 bg-white/5 backdrop-blur-sm">
      <div className="container px-4">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {stats.map((stat) => (
            <div key={stat.label} className="text-center">
              <div className={`inline-flex p-3 rounded-2xl bg-white/5 mb-4 ${stat.color}`}>
                <stat.icon className="w-6 h-6" />
              </div>
              <div className="text-3xl md:text-4xl font-display font-bold text-white mb-1">{stat.value}</div>
              <div className="text-sm text-muted-foreground uppercase tracking-wider font-medium">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
